import { render, staticRenderFns } from "./edit-table.vue?vue&type=template&id=f1576f86&scoped=true"
import script from "./edit-table.vue?vue&type=script&lang=ts"
export * from "./edit-table.vue?vue&type=script&lang=ts"
import style0 from "./edit-table.vue?vue&type=style&index=0&id=f1576f86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1576f86",
  null
  
)

export default component.exports